export default __webpack_public_path__ + "privacy-policy.pdf";